import React from 'react';
import type { IconProps } from '../types';

export const MissingIcon = (props: IconProps) => <div>Missing icon</div>;

export default MissingIcon;
